import { SALE_CLEAR_OWNER_FIELDS } from './constants'

export function clearOwnerFields() {
  return {
    type: SALE_CLEAR_OWNER_FIELDS,
  }
}

export function reducer(state, action) {
  if (action.type === SALE_CLEAR_OWNER_FIELDS) {
    return {
      ...state,
      sale: {
        ...state.sale,
        integration_car_lot_id: null,
        integration_car_lot_name: null,
        integration_branch_office_id: null,
        integration_branch_office_name: null,
      }
    }
  } else {
    return state
  }
}
